import moment from 'moment'

export function validateDate(bindInitiated) {
  var count = 0
  var validateSavedData = !!bindInitiated
    ? moment(bindInitiated).format('YYYY-MM-DD')
    : null

  var currentDate = moment(moment(new Date()).format('YYYY-MM-DD'))

  validateSavedData = currentDate.diff(validateSavedData, 'days')

  if (validateSavedData < 7 && validateSavedData > -1 && validateSavedData != null) {
    for (var i = 1; i <= validateSavedData; i++) {
      const dt = new Date()
      dt.setDate(dt.getDate() - i)
      //Validating weekend days [0,6] //0-sunday & 6-saturday
      if ([0, 6].includes(dt.getDay())) {
        count++
      }
    }

    switch (count) {
      case 0:
        return validateSavedData < 5 ? 5 - validateSavedData : false
      case 1:
        return validateSavedData < 6 ? 6 - validateSavedData : false
      case 2:
        return validateSavedData < 7 ? 7 - validateSavedData : false
      default:
        return false
    }
  } else {
    return false
  }
}

export function validatePreviousDate(bindInitiated) {
  var count = 0

  if (!!bindInitiated) {
    count = new Date(bindInitiated).getDay() - 1

    //0-sunday & -1-saturday
    switch (count) {
      case 0:
        return moment(new Date(bindInitiated) - 3 * 24 * 60 * 60 * 1000)
      case -1:
        return moment(new Date(bindInitiated) - 2 * 24 * 60 * 60 * 1000)
      default:
        return moment(new Date(bindInitiated) - 1 * 24 * 60 * 60 * 1000)
    }
  } else {
    return false
  }
}
